var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.model==='com')?_c('WwwDeepmedicalComCn'):_c('WwwDeepmedicalNetCn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }